import React, { useState } from 'react';
import qs from 'qs';

import AppHeadPortal from '../portals/app-head-portal';
import AppInnerPortal from '../portals/app-inner-portal';

import IconClose from '../icons/icon-close';
import IconZoomusText from '../icons/icon-zoomus-text';
import IconPlus from '../icons/icon-plus';

import niftyLogo from '../images/nifty-logo-light.svg';

const ZoomFrame = ({ params, onLeave }) => {
    const [minimized, setMinimized] = useState(false);

    const handleIframeLoad = event => {
        if (!event.target) {
            return;
        }

        event.target.contentWindow.addEventListener('unload', () => {
            leave();
        })
    }

    const handleMinimizeClick = () => {
        setMinimized(true);
    }

    const handleExpandClick = () => {
        setMinimized(false);
    }

    const handleCloseClick = () => {
        leave();
    }

    const leave = () => {
        onLeave && onLeave();
    }

    if (!params) {
        return null;
    }

    return (
        <React.Fragment>
            <AppHeadPortal>
                <div className="header header-accent header-zoom">
                    <div className="header-main">
                        <img className="logo" src={niftyLogo} width="98px" alt="Nifty logo" />

                        <IconPlus className="icons-divider" />

                        <IconZoomusText size="18px" />
                    </div>

                    <div className="header-right">
                        <div className="header-utils-holder">
                            <div className="header-utils">
                                <div className="util">
                                    <div className="util-inner">
                                        {
                                            minimized ? (
                                                <button className="btn btn-medium btn-secondary" onClick={handleExpandClick}>Expand</button>
                                            ) : (
                                                <button className="btn btn-medium btn-secondary" onClick={handleMinimizeClick}>Minimize</button>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="util">
                                    <div className="util-inner">
                                        <button className="btn btn-icon btn-square btn-medium btn-transparent" onClick={handleCloseClick}><IconClose size="14px" /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AppHeadPortal>

            <AppInnerPortal>
                <iframe className={'zoom-frame' + (minimized ? ' minimized' : '')}  src={`/zoom-meeting.html?${qs.stringify(params)}`} onLoad={handleIframeLoad} />
            </AppInnerPortal>
        </React.Fragment>
    );
}

export default ZoomFrame;
